// 域名
export const host = [import.meta.env.VITE_API_DOMAIN, import.meta.env.VITE_PORT]
  .filter(Boolean)
  .join(':');

export const apiBaseUrl = host + '/api';
